// Module
var code = "<contract-form model=\"vm.contract\"\n    on-save=\"$close(model)\"\n    on-close=\"$close()\">\n</contract-form>\n";
// Exports
module.exports = code;